const Login = () => import("./Login/Login.vue");
const Auth = () => import("./Auth.vue");
const ResalesRegistration = () => import("../Resales/ResalesAdd/ResalesRegistration.vue");
const ForgotPassword = () => import("./Forgotpassword/Forgotpassword.vue");
// const RegisterStepTwo = () => import("./RegisterStepTwo.vue");
// const ResetPassword = () => import("./ResetPassword.vue");
// const NewPassword = () => import("./NewPassword.vue");

const AuthRoutes = {
  component: Auth,
  children: [
    {
      path: "",
      name: "null",
      component: Login,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },

    {
      path: "/revendedor-cadastro",
      name: "ResalesRegistration",
      component: ResalesRegistration,
      meta: {
        requiresAuth: false,
        requiresAdmin: false,
      },
    },
    {
      path: "/forgotpassword",
      name: "ForgotPassword",
      component: ForgotPassword,
      meta: {
        requiresAuth: false,
        requiresAdmin: false,
      },
    },
  ],
};

export default AuthRoutes;
